import { atom } from 'jotai';

let currentTimeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const setCurrentTimeZoneId = (timeZoneId: string) => {
    currentTimeZoneId = timeZoneId;
};

export const getCurrentTimeZoneId = () => currentTimeZoneId;

const currentTimeZoneIdAtom = atom(Intl.DateTimeFormat().resolvedOptions().timeZone);
export default currentTimeZoneIdAtom;
